import {
  getUrlParamByName
} from "../../../utils/get-url-param-by-name.js";

import {
  setCookie
} from "../../../utils/set-cookie.js";

import {
  PROPERTIES_TO_SAVE
} from "../const.js";

export default class UtmMakrs {
  init() {
    PROPERTIES_TO_SAVE
      .forEach((name) => this._savePropertyValueToCookies(name));
  }

  _savePropertyValueToCookies(name) {
    const value = getUrlParamByName(name);

    if (value) {
      let date = new Date(Date.now() + 604800e3);
      date = date.toUTCString();

      setCookie(name, value, {
        expires: date
      });
    }
  }
}
